import React from "react";
import clsx from "clsx";

import { ReactComponent as Logo } from "../../../assets/images/Career/Reference/logo.svg";
import { ReactComponent as HeroImg01 } from "../../../assets/images/Career/Reference/hero_img_01.svg";
import { ReactComponent as HeroImg02 } from "../../../assets/images/Career/Reference/hero_img_02.svg";
import commonStyles from "../CareerReference.module.scss";

import styles from "./Hero.module.scss";

const Hero = () => {
  return (
    <div className={styles.wrapper}>
      <Logo className={styles.logo} />
      <div className={styles.read}>
        <div className={styles.main}>
          <p className={clsx(commonStyles.title, styles.title)}>
            "将来"を広げよう。
          </p>
          <p className={clsx(commonStyles.text, styles.text)}>
            AIの進化で、今はない仕事が生まれる時代。
            <br className={commonStyles.isSp} />
            だからこそ、
            <br />
            「自分の得意なこと・価値観」を知ることが大切。
            <br />
            キャリア開拓モードは
            <br className={commonStyles.isSp} />
            「好き」や「得意」や「価値観」を
            <br className={commonStyles.isSp} />
            見える化します。
          </p>
        </div>
        <div className={styles.sub}>
          <p className={clsx(commonStyles.title, styles.title)}>
            自分の軸が見つかる、
            <br className={commonStyles.isSp} />
            未来を描けるようになる
          </p>
          <p className={clsx(commonStyles.text, styles.text)}>
            世界で活躍するあの人たちが、
            <br className={commonStyles.isSp} />
            自分の軸を見つけたように。
            <br />
            自分にとっての「これだ！」を見つけることが、
            <br className={commonStyles.isSp} />
            未来を切り拓く第一歩になる。
          </p>
        </div>
      </div>
      <div className={styles.image}>
        <p className={styles.title}>
          キャリア開拓モードが「好き」探しをお手伝い
        </p>
        <div className={styles.contents}>
          <HeroImg01 className={styles.img} />
          <HeroImg02 className={styles.img} />
        </div>
      </div>
      <p className={styles.message}>
        やりたいことがなくても大丈夫。
        <br />
        「好き」を見つけるところから、一緒に始めよう！
      </p>
    </div>
  );
};

export default Hero;
